import React from 'react'
import { Link } from 'react-router-dom'

const Blog = () => {
    return (
        <section className="blog py-80">
            <div className="container container-lg">
                <div className="row gy-5">
                    <div className="col-lg-8 pe-xl-4">
                        <div className="blog-item-wrapper">
                            <div className="blog-item">
                                <Link
                                    to="/blog-details"
                                    className="w-100 h-100 rounded-16 overflow-hidden"
                                >
                                    <img
                                        src="assets/images/thumbs/blog-img1.png"
                                        alt=""
                                        className="cover-img"
                                    />
                                </Link>
                                <div className="blog-item__content mt-24">
                                    <span className="blog-recent-article-btn py-4 px-24 rounded-8 mb-16">
                                        Recettes & Conseils
                                    </span>
                                    <h6 className="text-2xl mb-24">
                                        <Link to="/blog-details" className="blog-title-link">
                                            Comment Déguster le Khalie : 4 Façons Savoureuses
                                        </Link>
                                    </h6>
                                    <p className="text-gray-700 text-line-2">
                                        Le Khalie est un trésor de la cuisine marocaine, apprécié pour son goût intense et sa polyvalence. Voici quatre façons délicieuses de le déguster...
                                    </p>
                                    <div className="flex-align flex-wrap gap-24 pt-24 mt-24 border-top border-gray-100">
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-calendar">
                                                <i className="ph ph-calendar-dots" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-date-link"
                                                >
                                                    20 Décembre 2024
                                                </Link>
                                            </span>
                                        </div>
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-comment">
                                                <i className="ph ph-chats-circle" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-comment-link"
                                                >
                                                    12 Commentaires
                                                </Link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-item">
                                <Link
                                    to="/blog-details"
                                    className="w-100 h-100 rounded-16 overflow-hidden"
                                >
                                    <img
                                        src="assets/images/thumbs/blog-img2.png"
                                        alt=""
                                        className="cover-img"
                                    />
                                </Link>
                                <div className="blog-item__content mt-24">
                                    <span className="blog-recent-article-btn py-4 px-24 rounded-8 mb-16">
                                        Recettes & Conseils
                                    </span>
                                    <h6 className="text-2xl mb-24">
                                        <Link to="/blog-details" className="blog-title-link">
                                            Comment Déguster le Khalie : 4 Façons Savoureuses
                                        </Link>
                                    </h6>
                                    <p className="text-gray-700 text-line-2">
                                        Le Khalie est un trésor de la cuisine marocaine, apprécié pour son goût intense et sa polyvalence. Voici quatre façons délicieuses de le déguster...
                                    </p>
                                    <div className="flex-align flex-wrap gap-24 pt-24 mt-24 border-top border-gray-100">
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-calendar">
                                                <i className="ph ph-calendar-dots" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-date-link"
                                                >
                                                    20 Décembre 2024
                                                </Link>
                                            </span>
                                        </div>
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-comment">
                                                <i className="ph ph-chats-circle" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-comment-link"
                                                >
                                                    12 Commentaires
                                                </Link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-item">
                                <Link
                                    to="/blog-details"
                                    className="w-100 h-100 rounded-16 overflow-hidden"
                                >
                                    <img
                                        src="assets/images/thumbs/blog-img3.png"
                                        alt=""
                                        className="cover-img"
                                    />
                                </Link>
                                <div className="blog-item__content mt-24">
                                    <span className="blog-recent-article-btn py-4 px-24 rounded-8 mb-16">
                                        Recettes & Conseils
                                    </span>
                                    <h6 className="text-2xl mb-24">
                                        <Link to="/blog-details" className="blog-title-link">
                                            Comment Déguster le Khalie : 4 Façons Savoureuses
                                        </Link>
                                    </h6>
                                    <p className="text-gray-700 text-line-2">
                                        Le Khalie est un trésor de la cuisine marocaine, apprécié pour son goût intense et sa polyvalence. Voici quatre façons délicieuses de le déguster...
                                    </p>
                                    <div className="flex-align flex-wrap gap-24 pt-24 mt-24 border-top border-gray-100">
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-calendar">
                                                <i className="ph ph-calendar-dots" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-date-link"
                                                >
                                                    20 Décembre 2024
                                                </Link>
                                            </span>
                                        </div>
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-comment">
                                                <i className="ph ph-chats-circle" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-comment-link"
                                                >
                                                    12 Commentaires
                                                </Link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Pagination Start */}
                        <ul className="pagination flex-align flex-wrap gap-16">
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    <i className="ph-bold ph-arrow-left" />
                                </Link>
                            </li>
                            <li className="page-item active">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    01
                                </Link>
                            </li>
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    02
                                </Link>
                            </li>
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    03
                                </Link>
                            </li>
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    04
                                </Link>
                            </li>
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    05
                                </Link>
                            </li>
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    06
                                </Link>
                            </li>
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    07
                                </Link>
                            </li>
                            <li className="page-item">
                                <Link
                                    className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    to="#"
                                >
                                    <i className="ph-bold ph-arrow-right" />
                                </Link>
                            </li>
                        </ul>
                        {/* Pagination End */}
                    </div>
                    <div className="col-lg-4 ps-xl-4">
                        {/* Search Start */}
                        <div className="blog-sidebar border border-gray-100 rounded-8 p-32 mb-40">
                            <h6 className="text-xl mb-32 pb-32 border-bottom border-gray-100">
                                Search Here
                            </h6>
                            <form action="#">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control common-input bg-color-three blog-search-input"
                                        placeholder="Searching..."
                                    />
                                    <button
                                        type="submit"
                                        className="btn blog-search-btn text-2xl h-56 w-56 flex-center text-2xl input-group-text"
                                    >
                                        <i className="ph ph-magnifying-glass blog-search-icon" />
                                    </button>
                                </div>
                            </form>
                        </div>
                        {/* Search End */}
                        {/* Categories Start */}
                        <div className="blog-sidebar border border-gray-100 rounded-8 p-32 mb-40">
                            <h6 className="text-xl mb-32 pb-32 border-bottom border-gray-100">
                                Articles Récents
                            </h6>
                            <ul>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-recent-article-link"
                                    >
                                        <span>Khalie</span>
                                        <span className="w-40 h-40 flex-center rounded-4 blog-recent-article-btn">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-recent-article-link"
                                    >
                                        <span>Gâteaux Traditionnels</span>
                                        <span className="w-40 h-40 flex-center rounded-4 blog-recent-article-btn">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-recent-article-link"
                                    >
                                        <span>Prestige</span>
                                        <span className="w-40 h-40 flex-center rounded-4 blog-recent-article-btn">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-recent-article-link"
                                    >
                                        <span>Les Salés</span>
                                        <span className="w-40 h-40 flex-center rounded-4 blog-recent-article-btn">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-recent-article-link"
                                    >
                                        <span>Petits Salés</span>
                                        <span className="w-40 h-40 flex-center rounded-4 blog-recent-article-btn">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-recent-article-link"
                                    >
                                        <span>Les Amandes</span>
                                        <span className="w-40 h-40 flex-center rounded-4 blog-recent-article-btn">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-0">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-recent-article-link"
                                    >
                                        <span>Petits Sucrés</span>
                                        <span className="w-40 h-40 flex-center rounded-4 blog-recent-article-btn">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        {/* Categories End */}
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Blog